import { render, staticRenderFns } from "./UserSearchSelect.vue?vue&type=template&id=0ac0a372&scoped=true"
import script from "./UserSearchSelect.vue?vue&type=script&lang=js"
export * from "./UserSearchSelect.vue?vue&type=script&lang=js"
import style0 from "./UserSearchSelect.vue?vue&type=style&index=0&id=0ac0a372&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ac0a372",
  null
  
)

export default component.exports